import script from "./CoinsBoostBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinsBoostBlock.vue?vue&type=script&setup=true&lang=js"

import "./CoinsBoostBlock.vue?vue&type=style&index=0&id=b370ffb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b370ffb8"]])

export default __exports__